import { render, staticRenderFns } from "./GenericSvg.vue?vue&type=template&id=e06b5260&scoped=true&"
import script from "./GenericSvg.vue?vue&type=script&lang=js&"
export * from "./GenericSvg.vue?vue&type=script&lang=js&"
import style0 from "./GenericSvg.vue?vue&type=style&index=0&id=e06b5260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06b5260",
  null
  
)

export default component.exports